exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".warning-payment-late {\n    background-color: #ff3424 !important;\n    color: white !important;\n}", ""]);

